import React, { useState } from 'react';
import BillingPreviewList from '../../components/SchoolFees/BillingPreviewList';
import CustomBilling from './CustomBilling';

const BillingPreview = ({studentIds = null, billingType="normal"}) => {
   
   

    return (
        <>
               
        {billingType === "normal" ? (
            <BillingPreviewList studentIds={studentIds} />
        ) : (
            <CustomBilling studentIds={studentIds} />
        )}
    </>
               
                
    );
};

export default BillingPreview;
